export default {
  name: "Job Offer Information",
  prefix: "A",
  sections: [
    {
      //name: 'Employer - Identifiers', // this subtitle is not needed as per ticket OFLCW-2790.
      fields: [
        {
          code: "A.1",
          machine_name: "eta_790a_a1_job_title",
          widget: "text",
          label: "Job Title",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Job Title must contain at least 5 characters",
            },
          ],
          maxLength: 60,
          tooltip:
            "Enter the job title that most clearly describes the agricultural services or labor to be performed.",
        },
        {
          code: "A.2A",
          machine_name: "eta_790a_a2a_workers_needed_total",
          widget: "text",
          label: "Workers Needed - Total",
          validate: [
            "required",
            "number",
            {
              minValue: 1,
              message: "Workers Needed must be greater than zero.",
            },
          ],
          warning: {
            text: `Please double-check this entry for accuracy. You are requesting to employ more than 1,000 total workers under this job opportunity.`,
            isVisible: {
              when: "eta_790a_a2a_workers_needed_total",
              is: "1001",
              operator: ">=",
            },
          },
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip: `Enter the total number of workers needed.
            <br>
            <br>
            This is the total number of workers the employer plans to hire to address its temporary or seasonal labor needs
            during the period identified in Items A.3 and A.4. When calculating the total number of workers needed, include both:
            <br>
            <ul>
            <li>The number of former non-H-2A employees the employer anticipates will return—both those workers who can
            and who cannot reasonably return to their residence within the same day; and</li>
            <li>The number of additional workers the employer seeks to recruit through this H-2A clearance order and other H2A program recruitment (i.e., the number entered in Item A.2b).</li>
            </ul>`,
        },
        {
          code: "A.2B",
          machine_name: "eta_790a_a2b_workers_needed_h2a",
          widget: "text",
          label: "Workers Needed - H-2A",
          parse: "positiveWholeNumber",
          validate: [
            "required",
            "number",
            {
              minValue: 1,
              message:
                "Please double-check this entry for accuracy. You are requesting 0 H-2A workers.",
            },
            {
              fieldComparison: "eta_790a_a2b_workers_needed_h2a",
              message:
                "Please double-check this entry for accuracy. You cannot request to employ more H-2A workers than the total number of workers needed under this job opportunity.",
              needsFieldValues: true,
              extraData: {
                operator: "<=",
                valueOf: "eta_790a_a2a_workers_needed_total",
              },
            },
          ],
          warning: {
            text: `Please double-check this entry for accuracy. You are requesting to employ more than 1,000 total workers under this job opportunity.`,
            isVisible: {
              when: "eta_790a_a2b_workers_needed_h2a",
              is: "1001",
              operator: ">=",
            },
          },
          maxLength: 4,
          tooltip: `Of the total number of workers needed, entered in Item A.2a, enter the number of H-2A workers requested for
            temporary agricultural labor certification.
            <br>
            <br>
            This is the total number of additional temporary agricultural workers the employer needs, which the employer seeks
            to fill with H-2A workers, unless recruitment through this H-2A clearance order and other H-2A program recruitment
            efforts provide the employer with sufficient qualified, able, willing, and available U.S. worker referrals and/or
            applicants. Note that the number in Item A.2b will be reduced by one for each U.S. worker who is referred or applies
            for the job opportunity, who is not rejected for lawful job-related reasons.`,
        },
        {
          isGroup: {
            fieldLevelErrors: true,
            showIndividualFieldError: true,
            fields: [
              {
                code: "A.3",
                machine_name: "eta_790a_a3_begin_date",
                widget: "date",
                label: "First Date",
                maxDate: "eta_790a_a4_end_date",
                // dynamicUpdates: [
                //   {
                //     if: "2023-02-13",
                //     operator: ">=",
                //     set: "formVersionId",
                //     to: 2,
                //     elseTo: 1,
                //     resetFields: [
                //       "eta_790a_a10_frequency_of_pay",
                //       "eta_790a_d6_housing_type",
                //       "eta_790a_d9_housing_standards_local",
                //       "eta_790a_d9_housing_standards_state",
                //       "eta_790a_d9_housing_standards_swa",
                //       "eta_790a_d9_housing_standards_other_state",
                //       "eta_790a_d9_housing_standards_other",
                //       "eta_790a_d9_housing_standards_federal",
                //       "eta_790a_d9_housing_standards_other_text",
                //       "apply_extensions",
                //       {
                //         eta_790a_addendum_b_housing: [
                //           "housing_type",
                //           "applicable_housing_standards_local",
                //           "applicable_housing_standards_state",
                //           "applicable_housing_standards_swa",
                //           "applicable_housing_standards_other_state",
                //           "applicable_housing_standards_federal",
                //           "applicable_housing_standards_other",
                //           "applicable_housing_standards_other_text",
                //         ],
                //       },
                //     ],
                //   },
                // ],
                warnings: [
                  {
                    text: "<b>IMPORTANT NOTE</b>: You have entered an anticipated begin date of work (Field A.3) on or after 2/13/2023. In accordance with the Department’s transition procedures (20 CFR 655.102) under the 2022 H-2A Final Rule, this job order (Form ETA-790/790A) and related H-2A application (Form ETA-9142A) must be submitted on NEW approved OMB forms and processed under the procedures contained in the <b>2022 H-2A Final Rule.</b>",
                    isVisible: {
                      when: "eta_790a_a3_begin_date",
                      property: "eta_790a_a3_begin_date",
                      operator: ">=",
                      is: "2023-02-13",
                    },
                  },
                  {
                    text: "<b>IMPORTANT NOTE</b>: You have entered an anticipated begin date of work (Field A.3) before 2/13/2023. In accordance with the Department’s transition procedures (20 CFR 655.102) under the 2022 H-2A Final Rule, this job order (Form ETA-790/790A) and related H-2A application (Form ETA-9142A) must be submitted on approved OMB forms and processed under the procedures contained in the <b>prior 2010 H-2A Final Rule.</b>",
                    isVisible: {
                      when: "eta_790a_a3_begin_date",
                      property: "eta_790a_a3_begin_date",
                      operator: "<",
                      is: "2023-02-13",
                    },
                  },
                ],
                validate: [
                  "required",
                  // {
                  //   dateStartCheck: "eta_790a_h2a_revision",
                  //   message:
                  //     "Under a new pending H2-A revision due for publication on Oct. 7 2022, sheepherders may not file after Feb 04, 2023.",
                  //   needsFieldValues: true,
                  //   extraData: {
                  //     herdingField: "prelim_5_is_livestock",
                  //     herdingLessThanValue: -1,
                  //   },
                  // },
                  {
                    dateStartCheck: "eta_790a_a4_end_date",
                    message:
                      "Except in emergency situations (20 CFR 655.134) or for job opportunities involving herding or production of livestock on the range (20 CFR 655.205), the employer must submit this job order no more than 75 calendar days ahead and no fewer than 60 calendar days before the first date of need.",
                    needsFieldValues: true,
                    extraData: {
                      lessThanValue: 60,
                      greaterThanValue: 75,
                      emergencyField: "prelim_4_is_emergency",
                      emergencyGreaterThanValue: 75,
                      herdingField: "prelim_5_is_livestock",
                      herdingLessThanValue: -1,
                    },
                  },
                  {
                    dateStartEnd: "eta_790a_a4_end_date",
                    message: "First Date must occur before Last Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                    },
                  },
                ],
                tooltip:
                  "Enter the first date for the period of intended employment. Use a month/day/year (mm/dd/yyyy) format.",
              },
              {
                code: "A.4",
                machine_name: "eta_790a_a4_end_date",
                widget: "date",
                label: "Last Date",
                minDate: "eta_790a_a3_begin_date",
                warning: {
                  text: `The period of employment appears to be approximately 10 months or longer which, depending on the circumstances of the job opportunity, may require additional information to ensure the OFLC Certifying Officer that the employer’s need for the agricultural services or labor to be performed is temporary or seasonal nature. 20 CFR 655.103(d).  Employment is of a seasonal nature where it is tied to a certain time of year by an event or pattern, such as a short annual growing cycle or a specific aspect of a longer cycle, and requires labor levels far above those necessary for ongoing operations. Employment is of a temporary nature where the employer's need to fill the position with a temporary worker will, except in extraordinary circumstances, last no longer than 1 year.`,
                  isVisible: {
                    when: "eta_790a_a4_end_date eta_790a_a3_begin_date",
                    operator: "compareMultiDateValues",
                    is: {
                      operator: ">=",
                      type: "months",
                      value: "10",
                    },
                  },
                },
                validate: [
                  "required",
                  {
                    dateStartEnd: "eta_790a_a3_begin_date",
                    message: "Last Date must occur after First Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                    },
                  },
                ],
                tooltip:
                  "Enter the last date for the period of intended employment. Use a month/day/year (mm/dd/yyyy) format.",
              },
            ],
          },
        },
        {
          isGroup: {
            code: "A.5",
            machine_name: "eta_790a_a5_is_247",
            label:
              "Will this job generally require the worker to be on-call 24 hours a day and 7 days a week?",
            tooltip: `Select “YES” or “NO” to indicate whether the job opportunity generally requires the worker to be on-call 24 hours a day, 7
              days a week. For example, an employer submitting a job order for a job opportunity involving herding or production of
              livestock on the range, which requires the worker to be on-call up to 24/7, would mark “YES” and proceed to Item 8. All
              other employers must mark “NO” and complete Items A.6 and A.7.`,
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "A.6",
            machine_name: "_anticipated_days_hours",
            label:
              "Anticipated days and hours of work per week<br/><em>an entry is required for each box below</em>",
            tooltip: `Use Items 6a through 6h to identify the anticipated days and hours of work per day and per week. Use a numerical (99.99) format for each Item below. An entry is required for each box listed in this field. Enter 0 (zero) if work is not performed. Reminder: Employers may use the Form ETA-790A, Addendum C, to disclose additional information about the job opportunity (e.g., variations in anticipated days or hours of work per day and per week for different crops or agricultural activities), depending on the unique specifications of the employer's job opportunity.`,
            coloring: "grey",
            isVisible: {
              when: "eta_790a_a5_is_247",
              is: "NO",
            },
            fields: [
              {
                widget: "anticipated_date",
                label: "Sunday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6b_hours_sunday",
                choice: "Sunday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Monday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6c_hours_monday",
                choice: "Monday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Tuesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6d_hours_tuesday",
                choice: "Tuesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Wednesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6e_hours_wednesday",
                choice: "Wednesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Thursday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6f_hours_thursday",
                choice: "Thursday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Friday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6g_hours_friday",
                choice: "Friday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Saturday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6h_hours_saturday",
                choice: "Saturday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Total", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eta_790a_a6a_hours_total",
                name: "total",
                choice: "Total:",
                validate: [
                  "required",
                  {
                    minValue: 35,
                    message:
                      "Please verify the accuracy of the entries in this section. The job opportunity must offer full-time employment that is at least 35.00 hours per week.",
                  },
                ],
                parse: "positiveNumber",
              },
            ],
          },
        },
        {
          isGroup: {
            code: "A.7",
            machine_name: "_hourly_work_schedule",
            label: "Hourly Work Schedule",
            tooltip: `Use Items 7a and 7b to identify the normal daily work schedule for the job opportunity using the standard time in the area
            where the work is expected to be performed (e.g., 9 AM to 5 PM, 7 AM to 11 AM and 4 PM to 8 PM). Reminder:
            Employers may use the Form ETA-790A, Addendum C, to disclose additional information about the job opportunity (e.g.,
            different shifts or variations in normal daily work schedule for different crops or agricultural activities), depending on the
            unique specifications of the employer’s job opportunity.`,
            coloring: "grey",
            isVisible: {
              when: "eta_790a_a5_is_247",
              is: "NO",
            },
            fields: [
              {
                widget: "time",
                label: "Begin Time",
                machine_name: "eta_790a_a7a_hourly_schedule_begin",
                tooltip: `Enter the start time of the day that work will normally begin and select a checkbox to indicate whether the expected start time of work is “AM” or “PM”.`,
                validate: ["required"],
              },
              {
                widget: "time",
                label: "End Time",
                machine_name: "eta_790a_a7b_hourly_schedule_end",
                tooltip: `Enter the end time of the day that work will normally end and select a checkbox to indicate whether the expected end time of work is “AM” or “PM”.`,
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    // End of Employer Identifiers
    {
      divider: "hide",
      fields: [
        {
          code: "A.8A",
          machine_name: "eta_790a_a8a_job_duties",
          widget: "text_area",
          label:
            "Job Duties - Description of the specific services or labor to be performed. <br /> (Please begin response on this form and use Addendum C if additional space is needed.)",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Job Duties must contain at least 5 characters",
            },
            {
              maxLength: 4000,
            },
          ],
          rows: "12",
          inputLimit: 4000,
          tooltip: `Enter a description of the job duties or services to be performed in each crop activity or agricultural activity. Describe
            the work tasks that make up the job, summarizing each step as appropriate, and avoid using technical terms without
            properly defining or explaining them where usage is necessary. Reminder: Employers may use the Form ETA-790A,
            Addendum C, to disclose additional information about the job opportunity (e.g., duties or services related to different
            crops or agricultural activities), depending on the unique specifications of the employer’s job opportunity`,
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_job_duties",
      coloring: "blue",
      isModal: true,
      sectionHeader: "Material Terms and Conditions - Job Duties",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      master_fieldArray: "eta_790a_addendum_c",
      listType: "inline",
      modalFields: [
        {
          machine_name: "section_number",
          label:
            "Section/Item Number and Category of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Pay Deductions",
            "Job Requirements",
            "Meal Provision",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Referral and Hiring Instructions",
          ],
          disabled: true,
          initialValue: "Job Duties",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term Condition",
          widget: "text",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 3500,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
    {
      name: "Wage Information",
      fields: [
        {
          code: "A.8B",
          machine_name: "eta_790a_a8b_wage_offer",
          widget: "wage",
          label: "Wage Offer",
          validate: ["required"],
          tooltip: `Enter the wage that will be offered, advertised, and paid to workers performing the job duties or services in the crop
            activity or agricultural activity and, if applicable, distinct work task(s) performed within that crop activity or agricultural
            activity. If the employer offers a range of wage rates for each crop or agricultural activity (and, if applicable, distinct
            work task(s) performed within that crop activity or agricultural activity), enter the minimum wage offer in Item A.8b
            (Wage Offer). The employer should enter a rate that is no less than the highest applicable hourly wage rate from the
            sources listed in 20 CFR 655.120(a) in Item A.8b, including any hourly wage rate guarantee an employer offers in
            conjunction with piece rate(s). Note: The upper range of any wage offers will be collected in the “Piece Rate
            Units/Special Pay Information” fields in Item A.8e and in Form ETA-790A, Addendum A.`,
          maxLength: 4, // accounts for the "$" and decimals
          warnings: [
            {
              text: "The wage is less than the Adverse Effect Wage Rate.",
              isVisible: {
                when: "eta_790a_a8b_wage_offer",
                is: [
                  "eta_790a_c3_work_state_id",
                  "eta_790a_a8c_wage_offer_per",
                  "hour",
                ],
                operator: "minWageComparison",
              },
            },
            {
              // OFLCW-4407: warning text should be include rate for monthly herders.
              text: "The wage is less than the monthly Adverse Effect Wage Rate for Range Occupations.",
              isVisible: {
                when: "eta_790a_a8b_wage_offer",
                is: "OFLCW-4407",
                operator: "OFLCW-4407",
              },
            },
          ],
          info: {
            text: "Wage offer must meet the state's adverse effect wage rate requirement.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
        },
        {
          isGroup: {
            code: "A.8C",
            machine_name: "eta_790a_a8c_wage_offer_per",
            label: "Per",
            tooltip:
              "Select either “<b>HOUR</b>” or “<b>MONTH</b>” to identify the unit of pay for the wage offer entered in Item 8b. Mark only one box. See 20 CFR 655.120(a).",
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice: "Hour",
                value: "hour",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Month",
                value: "month",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "A.8D",
          machine_name: "eta_790a_a8d_piece_rate_offer",
          widget: "wage",
          label: "Piece Rate Offer",
          validate: [
            {
              valueChecker: "eta_790a_a8d_piece_rate_offer",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a8r_piece_rate_info",
                check: "ifValueExists",
              },
            },
          ],
          tooltip: `If applicable, enter the piece rate that will be offered, advertised, and paid to workers performing the job duties or
            services in the crop activity or agricultural activity and, if applicable, distinct work task(s) performed within that crop
            activity or agricultural activity.`,
          maxLength: 4, // accounts for the "$" and decimals
        },

        {
          code: "A.8E",
          machine_name: "eta_790a_a8r_piece_rate_info",
          widget: "text",
          label:
            "Piece Rate Units/ Estimated Hourly Rate/ Special Pay Information",
          validate: [
            {
              valueChecker: "eta_790a_a8r_piece_rate_info",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a8d_piece_rate_offer",
                check: "ifValueExists",
                operator: ">",
                value: "0",
              },
            },
          ],
          maxLength: 255,
          tooltip: `. If applicable, enter the piece rate units (e.g., tree size/spacing, weight/size/number of boxes picked/packed,
           dimensions of bags or boxes filled) and/or any other special pay information (e.g., performance bonuses or incentives
           associated with performing the job duties or services) or the upper end of a wage range offered for a particular crop
           activity or agricultural activity and, if applicable, distinct work task(s) performed within that crop activity or agricultural
           activity. Examples of piece rate units include 5/8 bushel, 90 pound bag or box, 10 box bin. Examples of other special
           pay information related to a particular crop activity or agricultural activity are additional pay per acre or based on crop
           yield. In addition, enter the estimated hourly wage rate equivalent for each piece rate or base rate and bonus that is
           offered for each activity and unit size, if applicable (i.e., what a worker might expect to earn per hour at this rate).
           See example below. Include or be prepared to make the method of calculating the estimated hourly wage rate
           equivalent(s) and supporting materials available to the SWA.
           <br>
           <br>
           <b>Important Note:</b> The estimated hourly equivalent is not the offered rate nor a guarantee. The offered rate and/or
           guaranteed hourly rate must be entered in Item A.8b-d, and the corresponding fields on the Form ETA-790A,
           Addendum A, if applicable. In addition, the wage rate guarantee requirement is explained in Section I, Item 11.
           Although not the offered rate nor a guarantee, the estimated hourly equivalent can be no less than the highest of the
           applicable Federal or State minimum or the prevailing hourly wage rate.`,
        },
        {
          isGroup: {
            code: "A.10",
            machine_name: "eta_790a_a10_frequency_of_pay",
            label: "Frequency of Pay",
            tooltip: `Select one of the available options to specify the frequency with which workers will be paid under this agricultural
              clearance order. In accordance with 20 CFR 655.122(m), the employer must state in the job offer the frequency with
              which the worker(s) will be paid, which must be at least twice monthly or according to the prevailing practice in the area of
              intended employment, whichever is more frequent.`,
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Weekly",
                value: "WK",
                validate: ["required"],
                clearSchema: ["eta_790a_a10_frequency_of_pay_other"],
              },
              {
                widget: "radio",
                choice: "Biweekly",
                value: "BW",
                validate: ["required"],
                clearSchema: ["eta_790a_a10_frequency_of_pay_other"],
              },
              {
                widget: "radio",
                choice: "Other (Specify)",
                value: "other",
                validate: ["required"],
              },
            ],
          },
        },
        {
          machine_name: "eta_790a_a10_frequency_of_pay_other",
          label: "Specify",
          widget: "text",
          validate: ["required"],
          maxLength: 15,
          isVisible: {
            when: "eta_790a_a10_frequency_of_pay",
            is: "other",
          },
        },
      ],
    },
    // End of Wage Info
    {
      divider: "hide",
      fields: [
        {
          code: "A.11",
          machine_name: "eta_790a_a11_deductions",
          widget: "text_area",
          label:
            "State all deduction(s) from pay and, if known, the amount(s).<br /> <i>(Please begin response on this form and use Addendum C if additional space is needed.) </i>",
          validate: [
            "required",
            {
              maxLength: 1000, // Refactor: add custom message prop
            },
          ],
          rows: "12",
          inputLimit: 1000,
          tooltip:
            "State all deduction(s) from the worker’s paycheck the employer is required to make by law and all other deductions, not required by law, that the employer will make from the worker’s paycheck and, if known, the amount(s) for each deduction.  Reminder: Employers may use the Form ETA-790A, Addendum C, to disclose additional information about the job opportunity (e.g., deductions), depending on the unique specifications of the employer’s job opportunity.",
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_pay_deductions",
      coloring: "blue",
      isModal: true,
      sectionHeader: "Material Terms and Conditions - Pay Deductions",
      openModalHeader: "Add Addendum C",
      master_fieldArray: "eta_790a_addendum_c",
      listType: "inline",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label:
            "Section/Item Number and Category of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Pay Deductions",
            "Job Requirements",
            "Meal Provision",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Referral and Hiring Instructions",
          ],
          disabled: true,
          initialValue: "Pay Deductions",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term Condition",
          widget: "text",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 3500,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
  ],
};
